<div class="inner">
  <router-outlet></router-outlet>
</div>
